import { Controller } from "@hotwired/stimulus"
import { Chart, BarController, BarElement, LinearScale, CategoryScale, Tooltip, Legend } from "chart.js"

Chart.register(BarController, BarElement, LinearScale, CategoryScale, Tooltip, Legend)

export default class extends Controller {
  static targets = ["canvas"]
  static values = {
    labels: Array,
    datasets: Object,
    statusConfig: Object
  }

  connect() {
    this.chart = new Chart(this.canvasTarget, {
      type: "bar",
      data: {
        labels: this.labelsValue,
        datasets: Object.entries(this.statusConfigValue).map(([key, config]) => ({
          label: config.label,
          data: this.datasetsValue[key],
          backgroundColor: config.color,
          borderRadius: 4,
          maxBarThickness: 28
        }))
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          intersect: false,
          mode: "index"
        },
        plugins: {
          legend: {
            position: "top",
            align: "end",
            labels: {
              padding: 16,
              usePointStyle: true,
              pointStyle: "rectRounded",
              font: { size: 11 }
            }
          },
          tooltip: {
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            padding: 12,
            titleFont: { size: 13 },
            bodyFont: { size: 12 }
          }
        },
        scales: {
          x: {
            grid: { display: false },
            ticks: {
              font: { size: 11 },
              color: "rgba(0, 0, 0, 0.4)",
              maxRotation: 45
            }
          },
          y: {
            beginAtZero: true,
            grid: { color: "rgba(0, 0, 0, 0.05)" },
            ticks: {
              precision: 0,
              font: { size: 11 },
              color: "rgba(0, 0, 0, 0.4)"
            }
          }
        }
      }
    })
  }

  disconnect() {
    if (this.chart) this.chart.destroy()
  }
}
